import { render, staticRenderFns } from "./TabLayout.vue?vue&type=template&id=e114f704&"
import script from "./TabLayout.vue?vue&type=script&lang=js&"
export * from "./TabLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports